import Vue from 'vue'
import App from './App.vue'
import RightsIndicator from './components/engine/rightsInspection/RightsIndicator.vue'
import vuetify from './plugins/vuetify'
import { applyTheme } from './services/theme'
import store from './store/store'
import globals from './services/globalFunctions'
import router from './services/customRouter.js'
import Toast from "vue-toastification";

import EchoPlugin from './services/echo.js'


import Mixin from "./mixins/Global";
Vue.mixin(Mixin)
    // Import the CSS or use your own!
import "vue-toastification/dist/index.css";

import './assets/globalstyle.css';

import 'leaflet/dist/leaflet.css'

import ModulesPlugin from '@/plugins/modules'
Vue.use(ModulesPlugin)

Vue.use(globals)

Vue.use(EchoPlugin)

const options = {
    position: "top-right",
    timeout: 5000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: true,
    closeButton: "button",
    icon: true,
    rtl: false
};


Vue.use(Toast, options);


Vue.component('main-component', require('./components/main/templates/mainTemplate.vue').default);

// composant qui permet de créer une modal par page
Vue.component('modal-template', require('./components/main/templates/modalTemplate.vue').default);

Vue.component('not-allowed', require('./components/outils/notAllowed.vue').default);
Vue.component('rights-indicator', RightsIndicator);



Vue.config.productionTip = false

new Vue({
    vuetify,
    router,
    store,

    computed: {

        prefs() {
            return this.$store.getters.currentUser.preferences;
        },
        metierTheme() {
            return this.$store.getters.currentUser.theme;
        }
    },
    watch: {

        prefs: {
            // permet de rafraichir quand la modal de la page se ferme
            handler(val) {
                applyTheme(this.$vuetify, this.metierTheme, val && val.darkmode);
            },
            immediate: true,
            deep: true,
        },
        metierTheme: {
            handler(val) {
                applyTheme(this.$vuetify, val, this.prefs && this.prefs.darkmode);
            },
            immediate: true,
            deep: true,
        }
    },
    created() {
        
          this.$root.checkConnectionAndEnter() 
    },

    methods : {

          checkConnectionAndEnter(redirect) {

            this.$store.dispatch('getoverlay', true);
            this.$store.dispatch('textOverlay', 'Connexion au serveur')
                // on va intérroger l'API, voir si le token est créé et si il est valide.
            this.$store.dispatch("setUser").then((resp) => {

                // si tout est ok, on charge toutes les pages
                this.$store.dispatch('textOverlay', 'Chargement des pages')
                this.getAllPages().then(() => {
                    this.$store.dispatch('SystemLoaded',true);
                    this.$store.dispatch('loadToken',localStorage.getItem('tokenMinu'))
                    this.$initEcho();
                    
                    this.$store.dispatch('getoverlay', false);
                    //si première connection, on redirige vers la page favorite

                    if (localStorage.getItem("firstConnect")) {
                        localStorage.removeItem("firstConnect")
                        const defaultPage = resp.user.preferences.onopen

                        if(redirect) {
                            let p = redirect;
                            if(redirect.url) p = {path:redirect.url, query : redirect.displays.parameters.query, params: redirect.displays.parameters.params};
                            this.$router.push(p).catch(() => {})                           
                            return;
                        } else
                        if (!defaultPage || typeof defaultPage == 'undefined') {

                            this.$router.push('/').catch(() => {})
                        } else {
                            this.$router.push({ name: defaultPage.name, params: defaultPage.params, query: defaultPage.querys }).catch(() => {})
                        }

                    }

                })

            }, () => {
                console.log('erreur de chargement',this.$route.name,'redirect : ',this.$route.query.redirect)
                    // si le token existe et qu'il n'est plus valide (ou qu'il n'existe pas), on repart sur login
                this.$store.dispatch('getoverlay', false);
               // const quer = (this.$route.name !== 'login' && this.$route.fullPath!='/login') ? { redirect: this.$route.fullPath } : {};
                //this.$router.push({path:'/login',query:quer}).catch(() => {})


            })


          }


    },

    render: h => h(App)
}).$mount('#app')
